var $ = require('js/sw-jquery/sw-jquery');

/**
 * For the top portion of the left nav in model edit- no-material-selected state
 *
 * Usage:
 *   data-sw-model-edit-navigation
 *   Container for the ModelEditMaterialNav
 *
 */
module.exports = function ($fragment) {

    $fragment.swFindWithSelf('[data-sw-model-edit-navigation]').each(function () {

        var $el = $(this);
        var modelId = $el.data('swModelEditNavigation');

        require(['js/lib/models/ModelManager', 'js/lib/views/ModelEditNavigation'], function (ModelManager, ModelEditNavigation) {
            ModelManager.amdNewModelEditModel(modelId, function (model) {
                var options = {
                    el: $el,
                    model: model
                };
                new ModelEditNavigation(options);
            });
        });

    });


};
